import styles from './playlistControls.module.scss';
import ReactDOM from 'react-dom';
import videojs from 'video.js';
import { ArrowForward } from '../../../assets/icons';
import React from 'react';
import { CustomVideoEvents } from '../../../helpers/enums';

const vjsButton = videojs.getComponent('Button');

const PlaylistNext: React.FC = () => {
  return (
    <div className={styles.playlistControl}>
      <ArrowForward />
    </div>
  );
};

class VjsPlaylistNext extends vjsButton {
  // Use Window events  since videojs only affect its components like control buttons but not our custom ones.
  private onButtonCLick = (): void => {
    this.player_.trigger(CustomVideoEvents.VIDEO_SKIP_NEXT);
  };

  constructor(player: videojs.Player, options?: videojs.ComponentOptions) {
    super(player, options);
    this.addClass('vjs-button-playlist-next');
    this.controlText('Next');

    this.enableTouchActivity();
    this.on('click', (): void => {
      this.onButtonCLick();
    });
    // use tap event only when TOUCH_ENABLED is not undefined
    this.on('tap', (): void => {
      this.onButtonCLick();
    });

    /* Bind the current class context to the mount method */
    this.mount = this.mount.bind(this);

    /* When player is ready, call method to mount React component */
    player.ready(() => {
      this.mount();
    });

    /* Remove React root when component is destroyed */
    this.on('dispose', () => {
      ReactDOM.unmountComponentAtNode(this.el());
    });
  }

  mount() {
    ReactDOM.render(<PlaylistNext />, this.el());
  }
}

export default VjsPlaylistNext;
